export enum OrderSideEnum {
  Buy = 'Buy',
  Sell = 'Sell',
  // TODO: Update (remove) this type if not to be used with SOR
  /**
   * Initially not supported by SOR
   */
  SellShort = 'SellShort',
}
